export default __webpack_public_path__ + "static/media/duplicate.67831d1e.svg";